import { CsAccordion } from '@sunrise/components'
import { componentUtils, contentByLabel } from '@sunrise/shared'
import { NOT_SET } from '@sunrise/tracking'
import { Cms } from '@sunrise/types'
import { PropType, computed, defineComponent } from 'vue'

export default defineComponent({
    name: 'HydratedStormLevelPanel',
    components: {
        CsAccordion,
    },

    props: {
        cmsContent: { type: Object as PropType<Cms.Content>, required: true },
    },
    setup(props) {
        const labelContent = computed(() => contentByLabel(props.cmsContent, 'Label'))
        const label = computed(() => componentUtils.renderCMSText(labelContent.value))
        const textContent = computed(() => contentByLabel(props.cmsContent, 'Text'))
        const text = computed(() => componentUtils.renderCMSText(textContent.value))

        const trackingData = {
            mslayer_element_data_id: 'ed0000310',
            mslayer_element_text: 'unwetter',
            mslayer_element_variant: 'default',
            mslayer_element_body_type: 'text_body',
            mslayer_element_count: NOT_SET,
            mslayer_element_position: NOT_SET,
            mslayer_element_id: NOT_SET,
            mslayer_affiliate_id: NOT_SET,
            mslayer_element_company_name: NOT_SET,
            mslayer_element_detail_start_date: NOT_SET,
        }

        const getTrackingData = () => {
            return trackingData
        }

        return {
            label,
            text,
            getTrackingData,
        }
    },
})
